import _get from "lodash/get";
import styled from 'styled-components';
import { lighten, rem } from 'polished';
import { baseTheme } from '~base-theme';
var CloseButton = styled.button.withConfig({
  displayName: "CloseButton",
  componentId: "dhycze-0"
})(["background-color:transparent;border:0;color:", ";cursor:pointer;line-height:1;margin-left:", ";order:1;padding:", " ", ";transition:color 0.15s ease-in-out;&,&:hover,&:focus,&:active{outline:0;text-decoration:none;}&:focus,&:active{color:", ";}"], function (_ref) {
  var theme = _ref.theme,
      alertType = _ref.alertType;
  return lighten(0.9, _get(theme, "base.colors[" + alertType + "]", baseTheme.base.colors[alertType]));
}, rem(16), rem(2), rem(6), function (_ref2) {
  var theme = _ref2.theme,
      alertType = _ref2.alertType;
  return lighten(0.5, _get(theme, "base.colors[" + alertType + "]", baseTheme.base.colors[alertType]));
});
export default CloseButton;